const ChevronTop = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="10.5"
      height="6"
      viewBox="0 0 10.5 6"
    >
      <path
        d="M.167-.183a.537.537,0,0,0,.808,0L4-3.491,7.025-.183a.537.537,0,0,0,.808,0,.667.667,0,0,0,0-.884L4.4-4.817a.537.537,0,0,0-.808,0L.167-1.067A.667.667,0,0,0,.167-.183Z"
        transform="translate(0 5)"
        fill="#fff"
      />
    </svg>
  );
};
export default ChevronTop;
